import { Constants } from '@adobe/aem-spa-page-model-manager'

import ComponentTypeRenderer from '../../../config/component-type-renderer'
import { RuleType } from '../../../utils/types'

interface ResponsiveContainerProps {
  componentProps: any
  ruleExpression: string
  condition?: string
  ruleType?: RuleType
  isInEditor?: boolean
}

const ResponsiveContainer = ({
  ruleExpression = '',
  condition,
  ruleType,
  componentProps,
  isInEditor = false
}: ResponsiveContainerProps) => {
  const renderContainer = (results: any) => {
    try {
      if (Object.keys(results).length > 0) {
        return results?.[Constants.ITEMS_ORDER_PROP]?.map((item: string | number, index: number) => {
          return (
            <div className={results?.columnClassNames?.[item]} key={index}>
              <ComponentTypeRenderer
                componentType={results?.[Constants.ITEMS_PROP]?.[item]?.[':type']}
                componentProps={results?.[Constants.ITEMS_PROP]?.[item]}
                ruleExpression={ruleExpression}
                condition={condition}
                ruleType={ruleType}
              />
            </div>
          )
        })
      }
      return <></>
    } catch (err) {
      console.error(err)
      if (isInEditor) {
        return <div className='editor-text'>Check Rules Configuration</div>
      }
    }
  }
  if (componentProps && Object.keys(componentProps).length > 0) {
    return (
      <>
        <div className='container responsivegrid' data-testid='responsive-container'>
          <div className='cmp-container'>
            <div className={componentProps?.gridClassNames}>{componentProps && renderContainer(componentProps)}</div>
          </div>
        </div>
      </>
    )
  }
  return <></>
}

export default ResponsiveContainer
